module.exports = __webpack_public_path__ + "img/wave.d0e78ae4.png";